<template>
  <div class="contents new-style">
    <header
      class="sticky top-0 z-1000 w-full h-64px px-20px bg-16151A flex items-center justify-between min-W"
    >
      <Row class="flex-1 h-full min-w-0px" y="c">
        <Row class="shrink-0 mr-40px cursor-pointer" y="c" @click="toHome">
          <img
            alt="BiFinance"
            class="w-116px h-24px mr-8px"
            src="@/image/home/logo-dark.webp"
          >
          <span class="text-22px leading-24px weight-500 text-06F0C6">ECO</span>
        </Row>

        <Row class="h-full min-w-0px gap-4px" y="c">
          <Row
            v-for="item in navList"
            :key="item.key"
            class="relative h-32px px-12px rounded-999px shrink-0 text-14px weight-700 whitespace-nowrap select-none pointer"
            :class="'text-white'"
            y="c"
            @click="toNav(item)"
          >
            <div
              v-if="item.path === businessPath"
              class="absolute left-1/2 -translate-x-1/2 w-120px h-64px pointer-events-none"
              style="
                top: -16px;
                background: radial-gradient(50% 50% at 50% 85%, rgba(6, 240, 198, 0.6) 0%, rgba(6, 240, 198, 0) 100%);
                filter: blur(12px);
                clip-path: inset(0px -100px 0px -100px);
              "
            />
            <img
              v-if="item.key === 'HashrateSubscription'"
              class="w-20px h-20px mr-4px shrink-0 z-1"
              src="@/image/user/hot.gif"
            >
            <span class="z-1">{{ item.label }}</span>
          </Row>
        </Row>
      </Row>

      <rightMenu :isSmallScreen="isSmallScreen" gap="0" />
    </header>
  </div>
</template>

<script setup>
import { getBusinessPath } from '@/utils/localeRoute.js'
import rightMenu from './rightMenu/index.vue'

const route = useRoute()
const router = useRouter()
const businessPath = $computed(() => getBusinessPath(route.path))

const navList = $computed(() => [
  { label: $t('activity.eco.navHome'), key: 'EcoHome', path: '/ecoV2/ecoHome' },
  { label: $t('activity.eco.actionHashrateSubscription'), key: 'HashrateSubscription', path: '/ecoV2/HashrateSubscription' },
  { label: $t('activity.eco.tabStaking'), key: 'StakingPurchase', path: '/ecoV2/StakingPurchase' },
  { label: $t('activity.eco.tabRecommend'), key: 'Recommend', path: '/ecoV2/Recommend' },
  { label: $t('activity.eco.portfolioNav'), key: 'portfolio', path: '/ecoV2/portfolio' },
])

let isSmallScreen = $ref(window.innerWidth <= 1590)

const toNav = (item) => {
  if (item.path === businessPath) return
  router.push(item.path)
}

const toHome = () => {
  if (businessPath === '/home') return
  router.push('/home')
}

onBeforeMount(() => {
  eventBus.on('onResize', () => {
    isSmallScreen = window.innerWidth <= 1590
  })
})
</script>
